/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const baseChallengeTranslationBodySchema = z.object({
  // Required
  lang: z.string().min(1),
  definition: z.string().min(1),

  // Optional
  title: z.string().nullable().optional(),
  definitionSimple: z.string().nullable().optional(),
  usageNotes: z.string().nullable().optional(),
  examples: z.string().nullable().optional(),
  verified: z.number().int().min(0).max(1).optional(),
  generatedAt: z.string().nullable().optional(),
});

export type IBaseChallengeTranslationBody = z.infer<typeof baseChallengeTranslationBodySchema>;
